<div class="table-container">
    <div class="full-sized grouped">
        <form [formGroup]="scheduleVehiclesForm">
            <fieldset class="fault-border">
                <legend class="fhd-legend">{{ '@vehicles' | translate }}</legend>
                <div class="fhd-border-group fhd-flex">
                    <mat-form-field appearance="fill" class="padded-input">
                        <mat-label>{{ '@manufacturer' | translate }}</mat-label>
                        <input matNativeControl type="text" formControlName="manufacturer">                        
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="fill" class="padded-input">
                        <mat-label>{{ '@model' | translate }}</mat-label>
                        <input matNativeControl type="text" formControlName="model">
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="fill" class="padded-input">
                        <mat-label>{{ '@type' | translate }}</mat-label>
                        <input matNativeControl type="text" formControlName="type">
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="fill" class="padded-input">
                        <mat-label>{{ '@startYear' | translate }}</mat-label>
                        <input matNativeControl type="number" formControlName="startYear">
                    </mat-form-field>
                    <br />
                    <mat-form-field appearance="fill" class="padded-input">
                        <mat-label>{{ '@endYear' | translate }}</mat-label>
                        <input matNativeControl type="number" formControlName="endYear">
                    </mat-form-field>
                </div>
                <div class="fhd-button-group fhd-border-group">
                    <button mat-raised-button color="primary" (click)="add()" class="form-button-align">
                        {{ (existingScheduleVehicle ? '@update' : '@add') | translate }}
                    </button>
                    <button mat-raised-button color="default" (click)="cancel()" class="form-button-align">
                        {{ '@cancel' | translate }}
                    </button>
                </div>
            </fieldset>
        </form>
    </div>
</div>